import Poi from "../../../views/Poi";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const PoiRoutes = [
  {
    menuName: MenuNames.WALKER,
    path: "/Poi",
    component: Poi,
    exact: true,
  },
];

export default PoiRoutes;
